import { z } from 'zod';
function LabelDefault(Schema) {
    return {
        getLabel(schema) {
            return schema._def.label;
        },
        setLabel(schema, label) {
            return new Schema({
                ...schema._def,
                label
            });
        }
    };
}
export const LabelDefaults = {
    string: LabelDefault(z.ZodString),
    number: LabelDefault(z.ZodNumber),
    boolean: LabelDefault(z.ZodBoolean),
    literal: LabelDefault(z.ZodLiteral),
    enum: LabelDefault(z.ZodEnum),
    null: LabelDefault(z.ZodNull),
    object: LabelDefault(z.ZodObject),
    array: LabelDefault(z.ZodArray),
    record: LabelDefault(z.ZodRecord),
    union: LabelDefault(z.ZodUnion),
    tuple: LabelDefault(z.ZodTuple),
    any: LabelDefault(z.ZodAny),
    nullable: {
        getLabel(schema) {
            return schema.unwrap().label;
        },
        setLabel(schema, label) {
            const innerType = schema.unwrap().setLabel(label);
            return new z.ZodNullable({
                ...schema._def,
                innerType
            });
        }
    },
    optional: {
        getLabel(schema) {
            return schema.unwrap().label;
        },
        setLabel(schema, label) {
            const innerType = schema.unwrap().setLabel(label);
            return new z.ZodOptional({
                ...schema._def,
                innerType
            });
        }
    },
    lazy: {
        getLabel(schema) {
            return schema._def.getter().label;
        },
        setLabel(schema, label) {
            const innerType = schema._def.getter().setLabel(label);
            return new z.ZodLazy({
                ...schema._def,
                getter: () => innerType
            });
        }
    },
    effects: {
        getLabel(schema) {
            return schema.innerType().label;
        },
        setLabel(schema, label) {
            const innerType = schema.innerType().setLabel(label);
            return new z.ZodEffects({
                ...schema._def,
                schema: innerType
            });
        }
    }
};
